import React from "react";
import { Button } from "@material-ui/core";
import { useMobileDetection } from "../../utils/deviceDetection";

const MAX_TOOLTIP_HEIGHT = 380; // Match CSS max-height so we can clamp position

const TutorialTooltip = ({ 
  step, 
  currentStep, 
  totalSteps, 
  highlightBox, 
  onNext, 
  onSkip 
}) => {
  const isMobile = useMobileDetection();
  
  const getTooltipStyle = () => {
    const padding = isMobile ? 10 : 20;
    const tooltipWidth = isMobile ? Math.min(280, window.innerWidth - 40) : 320;
    const minTop = padding;
    const maxTop = window.innerHeight - MAX_TOOLTIP_HEIGHT - padding;

    const clampTop = (desiredTop) =>
      Math.max(minTop, Math.min(maxTop, desiredTop));

    if (step.position === "bottom") {
      const desiredTop = highlightBox.top + highlightBox.height + padding;
      return {
        position: "fixed",
        top: `${clampTop(desiredTop)}px`,
        left: isMobile ? '50%' : `${Math.max(padding, Math.min(highlightBox.left, window.innerWidth - tooltipWidth - padding))}px`,
        transform: isMobile ? 'translateX(-50%)' : 'none',
        zIndex: 10000
      };
    }
    if (step.position === "top") {
      const desiredTop = highlightBox.top - MAX_TOOLTIP_HEIGHT - padding;
      return {
        position: "fixed",
        top: `${clampTop(desiredTop)}px`,
        left: isMobile ? '50%' : `${Math.max(padding, Math.min(highlightBox.left, window.innerWidth - tooltipWidth - padding))}px`,
        transform: isMobile ? 'translateX(-50%)' : 'none',
        zIndex: 10000
      };
    }
    if (step.position === "left") {
      return {
        position: "fixed",
        top: `${clampTop(highlightBox.top)}px`,
        right: isMobile ? 'auto' : `${window.innerWidth - highlightBox.left + padding}px`,
        left: isMobile ? '50%' : 'auto',
        transform: isMobile ? 'translateX(-50%)' : 'none',
        zIndex: 10000
      };
    }
    return {
      position: "fixed",
      top: `${clampTop(highlightBox.top)}px`,
      left: isMobile ? '50%' : `${Math.max(padding, Math.min(highlightBox.left + highlightBox.width + padding, window.innerWidth - tooltipWidth - padding))}px`,
      transform: isMobile ? 'translateX(-50%)' : 'none',
      zIndex: 10000
    };
  };

  const tooltipStyle = getTooltipStyle();
  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div
      className="tutorial-tooltip"
      onClick={(e) => e.stopPropagation()}
      style={{
        ...tooltipStyle,
        maxWidth: isMobile ? "calc(100vw - 40px)" : "320px",
        width: isMobile ? "280px" : "auto",
      }}
    >
      <div className="tutorial-tooltip-step">
        Step {currentStep + 1} of {totalSteps}
      </div>
      <div className="tutorial-tooltip-progress-container">
        <div 
          className="tutorial-tooltip-progress-bar"
          style={{ width: `${progress}%` }}
        />
      </div>
      <h3 className="tutorial-tooltip-title">
        {step.title}
      </h3>
      <p className="tutorial-tooltip-description">
        {step.description}
      </p>
      <div className="tutorial-tooltip-actions">
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onSkip();
          }}
          style={{
            color: "var(--color-text-secondary, #666666)",
            textTransform: "none"
          }}
        >
          Skip Tutorial
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          style={{
            backgroundColor: "var(--color-primary, #15803d)",
            color: "white",
            textTransform: "none"
          }}
        >
          {currentStep < totalSteps - 1 ? "Next" : "Got it!"}
        </Button>
      </div>
    </div>
  );
};

export default TutorialTooltip;

